module.exports = __webpack_public_path__ + "static/media/own-delivery-icon.20ad17f7.svg";